module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "anketa"
  }, [(!!_vm.description) ? _c('p', {
    staticClass: "anketa__description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _c('div', {
    staticClass: "anketa__body"
  }, [_vm._l((_vm.questions), function(ref, index) {
    var text = ref.text;
    var type = ref.type;

    return _c('FormRange', {
      key: index,
      staticClass: "anketa__slider",
      attrs: {
        "question": text,
        "type": type,
        "error": _vm.warning
      },
      model: {
        value: (_vm.formAnswers[index]),
        callback: function($$v) {
          _vm.$set(_vm.formAnswers, index, $$v)
        },
        expression: "formAnswers[index]"
      }
    })
  }), _c('ExtButton', {
    staticClass: "anketa__btn",
    attrs: {
      "size": "small",
      "wide": true
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.btnText))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4344346","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/anketa/Anketa.vue
// module id = aee8259b16626d009333
// module chunks = 5